module.exports = __webpack_public_path__ + "img/sub24.6239cb5b.jpg";